import { ILanguage } from './language';

export type LanguageOption = Omit<ILanguage, 'direction' | 'shortname'>;
